/* The pure rules the policy editor follows: what of a `when` being edited goes to the
   server, how typed emails split into tokens, and the limits' ranges. No React here. */
import type { RuleWhen } from "../../types";

/** What the server takes of a `when` being edited: a condition still empty is left out until
    it holds something, since the server refuses an empty one. */
export function wireOf(when: RuleWhen): RuleWhen {
  const out: RuleWhen = {};
  if (when.channels?.length) out.channels = when.channels;
  if (when.people?.length) out.people = when.people;
  if (when.answer?.key && when.answer.value.trim()) out.answer = { key: when.answer.key, value: when.answer.value.trim() };
  if (when.status?.length) out.status = when.status;
  return out;
}

export const sameWhen = (a: RuleWhen, b: RuleWhen) => JSON.stringify(wireOf(a)) === JSON.stringify(wireOf(b));

/** "@acme.com" or "asha@acme.com": a token of the email-or-domain list, as typed. */
export const tokensOf = (typed: string) => typed.split(/[\s,]+/).map((t) => t.trim()).filter(Boolean);

/** Budget: 0–100000, kept to the cent. Messages: a whole 1–1000. */
export const LIMIT_RULES = {
  daily_budget_usd: {
    valid: (v: number) => Number.isFinite(v) && v >= 0 && v <= 100_000,
    rounded: (v: number) => Math.round(v * 100) / 100,
    issue: "A budget from $0 to $100,000.",
  },
  message_limit: {
    valid: (v: number) => Number.isInteger(v) && v >= 1 && v <= 1000,
    rounded: (v: number) => v,
    issue: "A whole number from 1 to 1,000.",
  },
};
